import { useCallback } from "react";
import { useAuth0 } from "react-auth0-spa";
import { BenefitsTeamMessage, sendBenefitsTeamMessage } from "./benefitsSummary.api";

// Sends a message about one child's plan to the benefits team.
export function useMessageBenefitsTeam(clientId: number, planId: string) {
  const { getTokenSilently } = useAuth0();

  return useCallback(
    async (message: BenefitsTeamMessage) => {
      const accessToken = await getTokenSilently();
      await sendBenefitsTeamMessage(accessToken, { ...message, clientId, planId });
    },
    [getTokenSilently, clientId, planId]
  );
}
